// Type guard to check if a message is SimplifiedPreviewResult
export const isSimplifiedPreviewResult = message => {
  return 'llmResponse' in message && 'createdAt' in message;
};

// Type guard to check if a message is Message
export const isV2PreviewMessage = message => {
  return !isSimplifiedPreviewResult(message);
};